export default {
  root: {
    name: 'monitoria',
    displayName: 'Monitoramento',
    disabled: true,
  },
  routes: [
    {
      displayName: 'Aulas Práticas',
      disabled: true,
      children: [
        {
          name: 'ListarAulasPraticas',
          displayName: 'Listar Aulas',
          disabled: false,
          children: [
            {
              name: 'VisualizarEditarAulaPratica',
              displayName: 'Visualizar e Editar Aula Prática',
              disabled: true,
            }
          ]
        }
      ]
    },
    {
      displayName: 'Turmas Teóricas',
      disabled: true,
      children: [
        {
          name: 'ListarTurmasVirtuais',
          displayName: 'Turmas Virtuais',
          disabled: false,
          children: [
            {
            }
          ]
        },
        {
          name: 'ListarTurmasPresenciais',
          displayName: 'Turmas Presenciais',
          disabled: false,
          children: [
            {
            }
          ]
        }
      ]
    },
    {
      displayName: 'Alunos',
      disabled: true,
      children: [
        {
          name: 'ListarAulasPraticas',
          displayName: 'Listar Aulas',
          disabled: false,
          children: [
            {
              name: 'VisualizarEditarAulaPratica',
              displayName: 'Visualizar e Editar Aula Prática',
              disabled: true,
            }
          ]
        }
      ]
    },
  ]
}
